import { EnvironmentProviders } from '@angular/core';
import { GlobalConfig, provideToastr } from 'ngx-toastr';
import { JoiiSnackbarToastrComponent } from 'src/shared/components/joii-snackbar-toastr/joii-snackbar-toastr.component';

const DEFAULT_JOII_TOASTR_CONFIG: Partial<GlobalConfig> = {
  timeOut: 10000,
  positionClass: 'toast-bottom-center',
  toastComponent: JoiiSnackbarToastrComponent,
  toastClass: 'ngx-toastr joii-snackbar-toastr',
};

export function provideJoiiToastr(config: Partial<GlobalConfig> = {}): EnvironmentProviders {
  return provideToastr({
    ...DEFAULT_JOII_TOASTR_CONFIG,
    ...config,
  });
}
